import { Magic } from "magic-sdk";
import { OAuthExtension } from '@magic-ext/oauth2';

export const magic = new Magic("pk_live_D8E4E76F62E7CD87", {
    extensions: [new OAuthExtension()],
});